export enum LocationTypeEndpoints {
  FetchLocationTypes = '/location-types',
}
